export default [
  { title: 'RU', value: 'ru' },
  { title: 'EN', value: 'en' }
]

export const contentLocales = [
  {
    title: 'RU',
    value: 'ru'
  },
  {
    title: 'EN',
    value: 'en'
  },
  {
    title: 'KO',
    value: 'ko'
  },
  {
    title: 'JA',
    value: 'ja'
  },
  {
    title: 'ZH',
    value: 'zh'
  }
]

export const contentLocalesValues = () => {
  return contentLocales.map(l => l.value)
}
